// extracted by mini-css-extract-plugin
export default {"lds-dual-ring":"LoadingSpinner_lds-dual-ring__5mxU5","loading-spinner__overlay":"LoadingSpinner_loading-spinner__overlay__mLPnr"};